<app-loader *ngIf="isDisabled"></app-loader>
<div class="container">
    <!-- Header -->
    <div class="header">
        <h4>Device Management Dashboard</h4>
        <div class="header-actions">
            <button type="button" class="export-btn" (click)="ESS_SiteWiseDeviceDetailsSelect(true)">
                <i class="bi bi-file-earmark-arrow-down"></i> Export
            </button>
        </div>
    </div>

    <div class="row gx-3 gy-2 mb-2">
        <div class="col-md-3">
            <ng-select [items]="Branchs" [multiple]="true" bindLabel="BranchName" bindValue="BranchMasterID"
                placeholder="All Branch" [closeOnSelect]="false" [(ngModel)]="mfilter.BranchMasterID"
                [virtualScroll]="true" (change)="DropdownChange('Branch')">
                <ng-template ng-header-tmp let-items="items">
                    <input type="checkbox" (change)="CheckAll($event,'Branch')" /> Check All
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                        [ngModelOptions]="{ standalone : true }" />
                    <span [ngbTooltip]="item.BranchName">{{item.BranchName}}</span>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                        <span class="ng-value-label">{{item.BranchName}}</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">{{items.length - 1}} more...</span>
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <div class="col-md-3">
            <ng-select [items]="Clients" [multiple]="true" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                placeholder="All Client" [closeOnSelect]="false" [(ngModel)]="mfilter.ClientGroupMasterID"
                [virtualScroll]="true" (change)="DropdownChange('Client')">
                <ng-template ng-header-tmp let-items="items">
                    <input type="checkbox" (change)="CheckAll($event,'Client')" /> Check All
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                        [ngModelOptions]="{ standalone : true }" />
                    <span [ngbTooltip]="item.ClientGroupName">{{item.ClientGroupName}}</span>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                        <span class="ng-value-label">{{item.ClientGroupName}}</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">{{items.length - 1}} more...</span>
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <div class="col-md-3">
            <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" bindValue="SiteMasterID"
                placeholder="All Site" [closeOnSelect]="false" [(ngModel)]="mfilter.SiteMasterID" [virtualScroll]="true" >
                <ng-template ng-header-tmp let-items="items">
                    <input type="checkbox" (change)="CheckAll($event,'Site')" /> Check All
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                        [ngModelOptions]="{ standalone : true }" />
                    <span [ngbTooltip]="item.SiteName">{{item.SiteName}}</span>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                        <span class="ng-value-label">{{item.SiteName}}</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">{{items.length - 1}} more...</span>
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <!-- <div class="col-md-3">
            <ng-select [items]="SiteOwners" [multiple]="true" bindLabel="SiteOwnerName" bindValue="SiteOwnerID"
                placeholder="All Supervisor" [closeOnSelect]="false" [(ngModel)]="mfilter.SiteOwnerID"
                [virtualScroll]="true">
                <ng-template ng-header-tmp let-items="items">
                    <input type="checkbox" (change)="CheckAll($event,'SiteOwner')" /> Check All
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                        [ngModelOptions]="{ standalone : true }" />
                    <span [ngbTooltip]="item.SiteOwnerName">{{item.SiteOwnerName}}</span>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                        <span class="ng-value-label">{{item.SiteOwnerName}}</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">{{items.length - 1}} more...</span>
                    </div>
                </ng-template>
            </ng-select>
        </div> -->
        <div class="col"></div>
        <div class="col-auto">
            <button class="btn btn-primary" type="button" (click)="ESS_SiteWiseDeviceDetailsSelect()"
                [disabled]="isDisabled"><i class="bi bi-funnel me-2" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Apply':'Applying...'}}
            </button>
        </div>
    </div>

    <!-- Summary Cards -->
    <div class="summary-section pt-2">
        <div class="summary-card total-devices cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 1}"
            (click)="FilterData(1); $event.stopPropagation()">
            <div class="card-title">Total Devices</div>
            <div class="card-value">{{Card.Online + Card.Offline}}</div>
        </div>

        <div class="summary-card online-devices cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 2}"
            (click)="FilterData(2); $event.stopPropagation()">
            <div class="card-title">Online Devices</div>
            <div class="card-value">{{Card.Online}}</div>
            <div class="card-change positive">
                <i class="fas fa-arrow-up"></i> {{Card.OnlinePer}}% online rate
            </div>
        </div>

        <div class="summary-card offline-devices cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 3}"
            (click)="FilterData(3); $event.stopPropagation()">
            <div class="card-title">Offline Devices</div>
            <div class="card-value">{{Card.Offline}}</div>
            <div class="card-change negative">
                <i class="fas fa-arrow-down"></i> {{Card.OfflinePer}}% offline rate
            </div>
        </div>
    </div>

    <div class="main-content">
        <div class="content-header">
            <h2>Device Records</h2>
        </div>
        <table datatable [dtOptions]="this.dtoptions" width="100%" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;">#</th>
                    <th style="width: 230px;">Action</th>
                    <th style="width: 150px;">Status / Date</th>
                    <th>Device Serial No</th>
                    <th style="width: 150px;">Device Last Sync</th>
                    <th style="width: 150px;">Ess Last Sync</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Data; let i = index">
                    <th scope="row" style="width: 5px;">{{ i + 1 }}</th>
                    <td style="width: 230px;">
                        <button type="button" class="btn btn-outline-primary btn-sm me-1"
                            style="font-size: 0.75rem; padding: 0.25rem 0.5rem;"
                            [routerLink]="['/attendancedevice/device/deviceattendance/'+element['serial_num']]">
                            <i class="bi bi-people-fill me-1"></i> Attendance
                        </button>

                        <button type="button" class="btn btn-outline-primary btn-sm"
                            style="font-size: 0.75rem; padding: 0.25rem 0.5rem;"
                            [routerLink]="['/attendancedevice/device/deviceemployee/'+element['serial_num']]">
                            <i class="bi bi-person-lines-fill me-1"></i> Employeee
                        </button>
                    </td>
                    <td style="width: 150px"> <span class="badge"
                            [ngClass]="{'warning':element['status'] == 0,'success':element['status'] == 1}">
                            {{element['status'] == 0?'Offline':'Online'}}</span>
                        <br />{{element['DeviceONOFFDate']}}
                    </td>
                    <td> {{element['serial_num']}} <i class="editIcon bi bi-gear-wide-connected ms-1"
                            [routerLink]="['/attendancedevice/device/deviceconfiguration/'+element['serial_num']]"></i>
                    </td>
                    <td style="width: 150px;">{{element['LastDeviceRecode']}}</td>
                    <td style="width: 150px;">{{element['LastSyncRecodeOn']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>